var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductShowcaseFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1206.8,565.1c-42.1-26.9-91.1-41.2-141.1-41.1c-87.7,0-172.9,43.7-222.1,120.6 C793.2,516.5,671.2,442,545,442c-60.9,0-120.5,17.4-171.8,50.2c-17.4,63.7-14.6,131.2,8.1,193.2 c47.1,129.3,166.7,206.8,292.4,210.4c2.8,0.1,5.7,0.1,8.5,0.1h122.7c2,21.2,3.1,42.7,3.1,64c0,40.2-3.8,86-10.5,128H712 c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h240c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8h-90.1c6.9-42.3,10.2-85.1,10.1-128 c0-21.3-0.9-42.8-2.8-64h85c106,0,206.2-64,245.9-172.5C1218.7,672.7,1221.1,617.3,1206.8,565.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128,192h832v248c0,4.4,3.6,8,8,8h48c4.4,0,8-3.6,8-8V160c0-17.7-14.3-32-32-32H96c-17.7,0-32,14.3-32,32v640 c0,17.7,14.3,32,32,32h216c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8H128V664.8l187.3-187.3c3-3,4.7-7.1,4.7-11.3v-64.6 c0-4.4-3.6-8-8-8c-2.1,0-4.2,0.8-5.7,2.3L128,574.3V192z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShowcaseFilled);
export default __webpack_public_path__ + "static/media/productShowcaseFilled.3286e9b842ecadd373023db93df651c9.svg";
export { ForwardRef as ReactComponent };